<template lang="">
    <v-container class="mt-7"
    style="background-color: #F9F9FC;"> 
          <h2>Revenue</h2>
           <TableuVue :width="width" :url="url"/>
    </v-container>
</template>
<script>
import TableuVue from '@/components/Tableu.vue'

export default {
    components:{
        TableuVue
    },
    data(){
        return{
            url:null,
            width:"100%",
        }
    }, 
    methods:{
         getLinkTablue(){
            let link= this.$session.getAll().user.tableau_list
            link.forEach(x =>{
               if(x.purpose =="lockerevenue"){
                    this.url = x.link   
               }
            } )
        }
    },
    mounted () {
       if (localStorage.getItem('reloaded')) {   
        localStorage.removeItem('reloaded');
    } else { 
        localStorage.setItem('reloaded', '1');
        location.reload();
    }
  },
   created(){
    this.getLinkTablue()
  }
 

}
</script>
<style lang="">
    
</style>



